module.exports = __webpack_public_path__ + "img/star_yellow_24dp.132d9d83.svg";